<template>
	<div class="fcs-bracket-challenge-bracket-result-page">
		<div class="fcs-bracket-challenge-bracket-result-page__content" v-if="!httpInProgress && pool != null">
			<section class="header">
				<select class="header__select-bracket" name="" id="" @change="changeBracket" v-model="selectedBracket">
					<option v-for="bracket in brackets" :value="{entryId: bracket.entry_id, bracketId: bracket.id}" :key="bracket.id">{{ bracket.name }}</option>
				</select>
			</section>

			<section class="bracket" v-if="!incompleteBracket">
				<div class="bracket__header">
					<div class="bracket__header--round bracket__header--first-round1">
						<p>First Round</p>
					</div>
					<div class="bracket__header--round bracket__header--second-round1">
						<p>Second Round</p>
					</div>
					<div class="bracket__header--round bracket__header--quarterfinals1">
						<p>Quarterfinals</p>
					</div>
					<div class="bracket__header--round bracket__header--semifinals1">
						<p>Semifinals</p>
					</div>
					<div class="bracket__header--round bracket__header--championship">
						<p>Championship</p>
					</div>
					<div class="bracket__header--round bracket__header--semifinals2">
						<p>Semifinals</p>
					</div>
					<div class="bracket__header--round bracket__header--quarterfinals2">
						<p>Quarterfinals</p>
					</div>
					<div class="bracket__header--round bracket__header--second-round2">
						<p>Second Round</p>
					</div>
					<div class="bracket__header--round bracket__header--first-round2">
						<p>First Round</p>
					</div>
					<div class="bracket__header--round bracket__header--spacer">
						<p></p>
					</div>
				</div>

				<div class="bracket__content">
					<div class="bracket__content--first-round1">
						<bracket-game-result class="bracket-game-1" :gameData="bracket.games[0]"></bracket-game-result>
						<bracket-game-result class="bracket-game-2" :gameData="bracket.games[1]"></bracket-game-result>
						<bracket-game-result class="bracket-game-3" :gameData="bracket.games[2]"></bracket-game-result>
						<bracket-game-result class="bracket-game-4" :gameData="bracket.games[3]"></bracket-game-result>
					</div>

					<div class="bracket__content--second-round1">
						<bracket-game-result class="bracket-game-9" :gameData="bracket.games[8]" :previousGame2Data="bracket.games[0]"></bracket-game-result>
						<bracket-game-result class="bracket-game-10" :gameData="bracket.games[9]" :previousGame2Data="bracket.games[1]"></bracket-game-result>
						<bracket-game-result class="bracket-game-11" :gameData="bracket.games[10]" :previousGame2Data="bracket.games[2]"></bracket-game-result>
						<bracket-game-result class="bracket-game-12" :gameData="bracket.games[11]" :previousGame2Data="bracket.games[3]"></bracket-game-result>
					</div>

					<div class="bracket__content--quarterfinals1">
						<bracket-game-result class="bracket-game-17" :gameData="bracket.games[16]" :previousGame1Data="bracket.games[8]" :previousGame2Data="bracket.games[9]"></bracket-game-result>
						<bracket-game-result class="bracket-game-18" :gameData="bracket.games[17]" :previousGame1Data="bracket.games[10]" :previousGame2Data="bracket.games[11]"></bracket-game-result>
					</div>

					<div class="bracket__content--semifinals1">
						<bracket-game-result class="bracket-game-21" :gameData="bracket.games[20]" :previousGame1Data="bracket.games[16]" :previousGame2Data="bracket.games[17]"></bracket-game-result>
					</div>

					<div class="bracket__content--championship">
						<bracket-game-result class="bracket-game-23" :gameData="bracket.games[22]" :previousGame1Data="bracket.games[20]" :previousGame2Data="bracket.games[21]"></bracket-game-result>
					</div>

					<div class="bracket__content--semifinals2">
						<bracket-game-result class="bracket-game-22" :gameData="bracket.games[21]" :previousGame1Data="bracket.games[18]" :previousGame2Data="bracket.games[19]"></bracket-game-result>
					</div>

					<div class="bracket__content--quarterfinals2">
						<bracket-game-result class="bracket-game-19"  :gameData="bracket.games[18]" :previousGame1Data="bracket.games[12]" :previousGame2Data="bracket.games[13]"></bracket-game-result>
						<bracket-game-result class="bracket-game-20"  :gameData="bracket.games[19]" :previousGame1Data="bracket.games[14]" :previousGame2Data="bracket.games[15]"></bracket-game-result>
					</div>

					<div class="bracket__content--second-round2">
						<bracket-game-result class="bracket-game-13"  :gameData="bracket.games[12]" :previousGame2Data="bracket.games[4]"></bracket-game-result>
						<bracket-game-result class="bracket-game-14"  :gameData="bracket.games[13]" :previousGame2Data="bracket.games[5]"></bracket-game-result>
						<bracket-game-result class="bracket-game-15"  :gameData="bracket.games[14]" :previousGame2Data="bracket.games[6]"></bracket-game-result>
						<bracket-game-result class="bracket-game-16"  :gameData="bracket.games[15]" :previousGame2Data="bracket.games[7]"></bracket-game-result>
					</div>

					<div class="bracket__content--first-round2">
						<bracket-game-result class="bracket-game-5" :gameData="bracket.games[4]"></bracket-game-result>
						<bracket-game-result class="bracket-game-6" :gameData="bracket.games[5]"></bracket-game-result>
						<bracket-game-result class="bracket-game-7" :gameData="bracket.games[6]"></bracket-game-result>
						<bracket-game-result class="bracket-game-8" :gameData="bracket.games[7]"></bracket-game-result>
					</div>

					<div class="bracket__content--champion">
						<h4>National Champion</h4>
						<div class="champion__content">
							<p :class="{ incorrect: bracket.games[22].game_pick.participant.eliminated, correct: bracket.games[22].winner_id == bracket.games[22].game_pick.participant.id }">{{ bracket.games[22].game_pick.participant.team.short_name }}</p>
						</div>
						<p class="incorrect-winning-team" v-if="bracket.games[22].winner_id != null && bracket.games[22].winner_id != bracket.games[22].game_pick.participant.id">{{ winner }}</p>
					</div>
				</div>
			</section>

			<div class="incomplete-bracket" v-if="incompleteBracket">
				<p>The picks in this bracket were incomplete.</p>
			</div>
		</div>
	</div>
</template>

<script>
	import { mapMutations, mapGetters, mapActions } from 'vuex'
	import axios from '@/axios'
	import BracketGameResult from '@/components/fcs-playoff-pools/BracketGameResult'

	export default {
		props: [ 'poolId', 'entryId', 'bracketId'],
		components: {
			'bracket-game-result': BracketGameResult
		},
		data() {
			return {
				pool: null,
				bracket: null,
				selectedBracket: { entryId: '', bracketId: ''},
				winner: '',
				incompleteBracket: false,
			}
		},
		computed: {
			...mapGetters([
				'httpInProgress'
			]),
			brackets() {
				var brackets = []
				if ("entries" in this.pool) {
					this.pool.entries.forEach(function(element) {
						element.brackets.forEach(function(el) {
							brackets.push(el)
						})
					})
				}

				brackets.sort(function(a, b) {
					if(a.score == b.score) {
						return b.possible - a.possible
					} else {
						return b.score - a.score
					}
				})

				return brackets
			},
		},
		methods: {
			...mapMutations([
				'HTTP_IN_PROGRESS',
				'HTTP_FINISHED'
			]),
			...mapActions([
				'attemptRefresh'
			]),
			getBracket(entryId, bracketId) {
				this.HTTP_IN_PROGRESS()
				axios.get('fcs-bracket-challenges/' + this.poolId + '/fcs-bracket-challenge-entry/' + entryId + '/fcs-bracket-challenge-bracket/' + bracketId)
					.then(response => {
						this.setBracket(response.data.data)
						this.HTTP_FINISHED()
					}).catch(() => {
						this.HTTP_FINISHED()
						this.$router.replace('/')
					})
			},
			setBracket(data) {
				this.bracket = data
				this.selectedBracket = { 
					entryId: this.bracket.entry_id,
					bracketId: this.bracket.id
				}
				this.setWinner()
			},
			setWinner() {
				if(this.bracket.games[22].winner_id == null) {
					this.winner = ''
				} else {
					this.bracket.games[22].participants.forEach((element) => {
						if(element.id == this.bracket.games[22].winner_id) {
							this.winner = element.school_short_name
						}
					})
				}
			},
			changeBracket() {
				this.getBracket(this.selectedBracket.entryId, this.selectedBracket.bracketId)
			},
			getPool() {
				return axios.get('fcs-bracket-challenges/' + this.poolId)
			}
		},

		created() {
			this.HTTP_IN_PROGRESS()
			this.getPool().then(response => {
				this.pool = response.data.data
				this.getBracket(this.entryId, this.bracketId)
			}).catch(() => {
				this.HTTP_FINISHED()
				this.$router.replace('/')
			})
		}
	}
</script>

<style lang="scss">
	@import '@/styles/app';
	@import '../../../styles/views/fcs/fcs-bracket-challenge/bracketResult';
</style>